import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import LevelScoreBadge from "./LevelScoreBadge";

DemandScore.propTypes = {
    score: PropTypes.number
};

// mirrors the back-end's groupSearchImpressions() thresholds (900 / 2000),
// collapsed to the 3 levels this badge displays (low / medium / high)
function formatDemandScore(searchImpressions) {
    if (searchImpressions < 900) {
        return 0;
    }

    if (searchImpressions < 2000) {
        return 1;
    }

    return 2;
}

function DemandScore({score = null}) {
    return (
        <>
            <FormattedMessage id='retailer.product.scoring.form.summary.demand.label' />
            <LevelScoreBadge
                score={score == null ? null : formatDemandScore(score) * 50}
                tooltipId={'retailer.product.scoring.form.summary.demand.tooltip'}
            />
        </>
    );
}

export default DemandScore;
